import type { AmplitudeEvent } from "@app/types/tracking/common";
import type {
  ClickedDownloadNativeApp,
  ClickResendConfirmationEmail,
  ClosedAccessTicketsPopup,
  FailResendConfirmationEmail,
  RatedApplication,
  RoundtripLinkClicked,
  SucceedResendConfirmationEmail
} from "@app/types/tracking/purchase-confirmation";

import { PurchaseTrackingAction } from "./constants/tracking-action";

export function clickResendConfirmationEmail(): AmplitudeEvent<ClickResendConfirmationEmail> {
  return {
    action: PurchaseTrackingAction.ClickResendConfirmationEmail,
    category: "purchase_confirmation",
    details: {}
  };
}

export function clickedDownloadNativeApp(
  platform: "ios" | "android"
): AmplitudeEvent<ClickedDownloadNativeApp> {
  return {
    action: PurchaseTrackingAction.ClickedDownloadNativeApp,
    category: "purchase_confirmation",
    details: { platform }
  };
}

export function succeedResendConfirmationEmail(): AmplitudeEvent<SucceedResendConfirmationEmail> {
  return {
    action: PurchaseTrackingAction.SucceedResendConfirmationEmail,
    category: "purchase_confirmation",
    details: {}
  };
}

export function failResendConfirmationEmail(): AmplitudeEvent<FailResendConfirmationEmail> {
  return {
    action: PurchaseTrackingAction.FailResendConfirmationEmail,
    category: "purchase_confirmation",
    details: {}
  };
}

export function roundtripLinkClicked(): AmplitudeEvent<RoundtripLinkClicked> {
  return {
    action: PurchaseTrackingAction.RoundtripLinkClicked,
    category: "rountrip_link",
    details: {}
  };
}

export function closeAccessTicketsPopup(): AmplitudeEvent<ClosedAccessTicketsPopup> {
  return {
    action: PurchaseTrackingAction.ClosedAccessTicketsPopup,
    category: "purchase_confirmation",
    details: {}
  };
}

type StarRating = 0 | 1 | 2 | 3 | 4 | 5;
type NPSRating = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
export type ThirdPartySurveyType = "google" | "trustpilot"; // REVIEW: Is there a better way to share type declarations?
type RateApplicationArgs =
  | [ThirdPartySurveyType, StarRating]
  | ["nps", NPSRating];

export function rateApplication(
  ...args: RateApplicationArgs
): AmplitudeEvent<RatedApplication> {
  const [survey_type, rating] = args;
  const max_rating = {
    trustpilot: 5,
    nps: 10,
    google: 0
  };
  const rating_percentage =
    Math.floor((rating / max_rating[survey_type]) * 100) / 100;

  return {
    action: PurchaseTrackingAction.RatedApplication,
    category: "purchase_confirmation",
    details: {
      survey_type,
      rating,
      rating_percentage
    }
  };
}
